export const CLINICS_LIST = [
  { name: 'Clínica Santa Isabel', url: 'http://www.santaisabel.com.ar/santaisabel/' },
  { name: 'Clínica Bazterrica', url: 'http://www.bazterrica.com.ar/bazterrica/' },
  { name: 'Clínica Del Sol', url: 'http://www.cdelsol.com.ar/dnn_clsol/' }
]

//Audit Actions
export const AUDIT_ACTION_LOGIN = 'Login'
